export default __webpack_public_path__ + "static/media/supine.b274e87b.png";